import React, { useCallback, useEffect, useState } from "react";
import { IInput, Input } from "shared/ui/input";
import { useDebouncedCallback } from "use-debounce";

export interface IInputDebounced extends Omit<IInput, "onChange"> {
  wait?: number;
  onChange?: (value: string | undefined) => void;
}

const nop = () => {};

export const InputDebounced = ({ wait = 500, value, onChange, ...props }: IInputDebounced) => {
  const [savedValue, setSavedValue] = useState(value);
  const propsOnChange = useDebouncedCallback(onChange || nop, wait);

  useEffect(() => {
    setSavedValue(value);
  }, [value]);

  const handleOnChange: React.ChangeEventHandler<HTMLInputElement> = useCallback(
    (e) => {
      setSavedValue(e.target.value);
      propsOnChange(e.target.value);
    },
    [setSavedValue, propsOnChange]
  );

  return <Input {...props} value={savedValue} onChange={handleOnChange} />;
};

InputDebounced.defaultProps = {};
